/**
 * @author      joseph.murphy@zumper.com (murph)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://github.com/chakra-ui/chakra-ui/blob/v1/packages/theme/src/components/accordion.ts

import { SystemStyleFunction, SystemStyleObject, mode } from '@chakra-ui/theme-tools'

import { focus } from '../sharedStyles/focus'

const baseStyleContainer: SystemStyleObject = {
  borderBottomWidth: 0,
  borderRightWidth: 0,
  borderLeftWidth: 0,
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'gray.150',
  _first: {
    borderTopWidth: 0,
  },
}

const baseStyleButton: SystemStyleObject = {
  padding: 2,
  borderRadius: 'base',
  fontSize: 'md',
  fontFamily: 'body',
  lineHeight: 1,
  textAlign: 'left',
  cursor: 'pointer',
  _focus: {
    outline: 'none',
    boxShadow: 'none',
  },
  _focusVisible: focus,
  _disabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
}

const baseStylePanel: SystemStyleObject = {
  py: 4,
  px: 3,
  fontFamily: 'body',
}

const baseStyleIcon: SystemStyleObject = {
  fontSize: 'xl',
}

const variantMain: SystemStyleFunction = (props) => ({
  container: {
    borderTopColor: mode('gray.150', 'whiteAlpha.400')(props),
  },
  button: {
    border: 0,
    background: 'transparent',
    color: mode('black', 'white')(props),
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: '0px 0px',
    _focus: {
      border: 0,
    },
    _hover: {
      background: mode('blackAlpha.50', 'whiteAlpha.200')(props),
    },
  },
})

const baseStyle = {
  root: {},
  container: baseStyleContainer,
  panel: baseStylePanel,
  icon: baseStyleIcon,
  button: baseStyleButton,
}

const variants = {
  main: variantMain,
}

export const Z4Accordion = {
  parts: ['root', 'button', 'panel', 'container'],
  defaultProps: {
    variant: 'main',
  },
  baseStyle,
  variants,
}
